commusoftCommon.filter('timeFormat', function(CS_LANGUAGE) {
    return function(dateString) {
        if(dateString == '' || dateString == null){
            return '';
        }
        moment.locale(CS_LANGUAGE);
        //check for diff zone uk for default +01:00
        return moment.utc(dateString).zone(moment().format('Z')).format('hh:mm A')
    };
});